import { baseUrl } from '@/lib/api/base-url'
import Client from '@/lib/api/client'

const SESSION_TOKEN_KEY = 'session_token'

export function getSessionToken(): string | null {
  return localStorage.getItem(SESSION_TOKEN_KEY)
}

export function setSessionToken(token: string): void {
  localStorage.setItem(SESSION_TOKEN_KEY, token)
  window.dispatchEvent(new CustomEvent('auth:change'))
}

export function clearSessionToken(): void {
  localStorage.removeItem(SESSION_TOKEN_KEY)
  window.dispatchEvent(new CustomEvent('auth:change'))
}

export function createAuthClient(): Client | null {
  const token = getSessionToken()
  if (!token) return null
  return new Client(baseUrl, {
    auth: { authorization: `Bearer ${token}` },
  })
}
